import { render, staticRenderFns } from "./mylink.vue?vue&type=template&id=3e45c1f1&"
import script from "./mylink.vue?vue&type=script&lang=js&"
export * from "./mylink.vue?vue&type=script&lang=js&"
import style0 from "./mylink.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports